export default __webpack_public_path__ + "static/media/04.a0b849b8.svg";